// Sidebar bileşeni - Sol menü navigasyonu
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ConfirmModal from '../Common/ConfirmModal';
import { 
  FiHome, 
  FiUsers, 
  FiFolder, 
  FiBarChart2, 
  FiSettings, 
  FiLogOut,
  FiX,
  FiMenu,
  FiFileText
} from 'react-icons/fi';

const Sidebar = ({ isOpen, onClose }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  // Menü öğeleri
  const menuItems = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: FiHome,
      permission: 'agent'
    },
    {
      name: 'Müşteriler',
      path: '/customers',
      icon: FiUsers,
      permission: 'agent'
    },
    {
      name: 'Projeler',
      path: '/projects',
      icon: FiFolder,
      permission: 'agent'
    },
    {
      name: 'Teklifler',
      path: '/offers',
      icon: FiFileText,
      permission: 'agent'
    },
    {
      name: 'Raporlar',
      path: '/reports',
      icon: FiBarChart2,
      permission: 'agent',
      hideForGuest: true // Guest kullanıcılar için gizle
    },
    {
      name: 'Kullanıcılar',
      path: '/users',
      icon: FiUsers,
      permission: 'admin',
      hideForGuest: true, // Guest kullanıcılar için gizle
      hideForUser: true // User kullanıcılar için gizle
    },
    {
      name: 'Ayarlar',
      path: '/settings',
      icon: FiSettings,
      permission: 'manager',
      hideForGuest: true, // Guest kullanıcılar için gizle
      hideForUser: true // User kullanıcılar için gizle
    }
  ];

  // Çıkış yapma fonksiyonu (onay modalı ile)
  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = async () => {
    await logout();
    setShowLogoutConfirm(false);
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div className={`
        sidebar transform transition-transform duration-300 ease-in-out z-50
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0 lg:static lg:transform-none
      `}>
        {/* Mobile kapatma butonu */}
        <div className="lg:hidden flex justify-end p-4">
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300"
          >
            <FiX size={24} />
          </button>
        </div>


        {/* Menü öğeleri */}
        <nav className="flex-1 py-4">
          {menuItems
            .filter((item) => {
              // Guest kullanıcılar için gizlenen öğeleri filtrele
              if (user?.user_type === 'guest' && item.hideForGuest) {
                return false;
              }
              // User kullanıcılar için gizlenen öğeleri filtrele
              if (user?.user_type === 'user' && item.hideForUser) {
                return false;
              }
              // İzin gereksinimi: Kullanıcılar menüsü sadece admin/manager
              if (item.path === '/users' && !['admin', 'manager'].includes(user?.user_type)) {
                return false;
              }
              return true;
            })
            .map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={onClose}
                className={`
                  sidebar-item flex items-center space-x-3
                  ${isActive ? 'active' : ''}
                `}
              >
                <Icon size={20} />
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>

        {/* Çıkış butonu */}
        <div className="border-t border-brand-secondary">
          <button
            onClick={handleLogout}
            className="sidebar-item flex items-center space-x-3 w-full text-left"
          >
            <FiLogOut size={20} />
            <span>Çıkış Yap</span>
          </button>
        </div>
      </div>

      {/* Logout Onay Modal'ı */}
      {showLogoutConfirm && (
        <ConfirmModal
          title="Çıkış Onayı"
          message="Çıkış yapmak istediğinize emin misiniz?"
          onConfirm={confirmLogout}
          onCancel={cancelLogout}
          confirmText="Çıkış Yap"
          cancelText="İptal"
        />
      )}
    </>
  );
};

export default Sidebar;
